module.exports = __webpack_public_path__ + "img/index-4-pic02@2x.ca78e8b7.png";